import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { getVisibleSnippetParts } from "../lib/getVisibleSnippetParts";
import styles from "./index.module.css";
export const HighlightedSnippet = ({ html }) => {
    const content = getVisibleSnippetParts(html).map((part, index) => (part.highlighted ? (_jsx("mark", Object.assign({ className: styles.highlight }, { children: part.text }), index)) : (_jsx(Fragment, { children: part.text }, index))));
    return _jsx("span", Object.assign({ className: styles.snippet }, { children: content }));
};
